<ion-grid class="ion-padding">
  <ion-row>
    <ion-col size="12">
      <ion-row>
        <ion-col size="12">
          <h4 regular class="text-primary-dark-50 ion-no-margin">{{'COMPONENTS.DESCRIPTION' | translate}}</h4>
          <h4 regular class="text-primary-dark ion-no-margin">
            <div
              [innerHTML]="surveyDescription ? surveyDescription : ('COMPONENTS.THERE_IS_NO_DESCRIPTION' | translate)">
            </div>
          </h4>
        </ion-col>
        <ion-col size="12">
          <h4 regular class="text-primary-dark-50 ion-no-margin">{{'COMPONENTS.OBSERVATION' | translate}}</h4>
          <h4 regular class="text-primary-dark ion-no-margin">
            <div
              [innerHTML]="surveyObservation ? surveyDescription : ('COMPONENTS.THERE_IS_NO_OBSERVATION' | translate)">
            </div>
          </h4>
        </ion-col>
      </ion-row>
    </ion-col>
  </ion-row>
</ion-grid>